import Api from './../api'

export default DataLayer => DataLayer.$extend('models', {
    dispatch(modelsInput) {
        return Api.models.dispatch({ models: modelsInput, depth: 2 })
    },
})
